export default __webpack_public_path__ + "static/media/google.7a06e75d.svg";